const QUESTS_DATA = [
    {
        id: 1,
        name: "principal quests",
        objective: "meet with michael in the sewers",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
        numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
        optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
        obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
        nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
        tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
        quia. `,
        rewards: 20000,
        assignedBy: "troy",
        location: "old town",
        selected: true,
    },
    {
        id: 2,
        name: "gunslinger",
        objective: "kill the gunslinger in old town",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
        numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
        optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
        obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
        nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
        tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
        quia. `,
        rewards: 40000,
        assignedBy: "michael",
        location: "old town",
        selected: false,
    },
    {
        id: 3,
        name: "incence herbs",
        objective: "find three incence herbs to protect you from a cold.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
        numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
        optio, eaque rerum! Provident similique accusantium nemo autem.`,
        rewards: 25000,
        assignedBy: "troy",
        location: "old town",
        selected: false,
    },
    {
        id: 4,
        name: "witch queen",
        objective: "Find the witch queen in the dark forest.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
        numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
        optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
        obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
        nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
        tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
        quia. `,
        rewards: 30000,
        assignedBy: "troy",
        location: "dark forest",
        selected: false,
    },
    {
        id: 5,
        name: "repert the gunsmith",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
        numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
        optio, eaque rerum! Provident similique accusantium nemo autem.`,
        rewards: 15000,
        assignedBy: "douglas",
        location: "monte everest",
        selected: false,
    },
    {
        id: 6,
        name: "fountain",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae   consequuntur voluptatum laborum
        numquam blanditiis harum quisquam eius sed odit fugiat  iusto fuga praesentium
        optio, eaque rerum! Provident similique accusantium nemo autem.`,
        rewards: 15000,
        assignedBy: "douglas",
        location: "monte everest",
        selected: false,
    },
    {
        id: 7,
        name: "radio station",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 10000,
        assignedBy: "milita",
        location: "green park",
        selected: false,
    },
    {
        id: 8,
        name: "legless spider",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 60000,
        assignedBy: "shoperu",
        location: "crossroad fire",
        selected: false,
    },
    {
        id: 9,
        name: "bandages and meds",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 60000,
        assignedBy: "shoperu",
        location: "crossroad fire",
        selected: false,
    },
    {
        id: 10,
        name: "lighter gas",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 30000,
        assignedBy: "motitua",
        location: "ocean blark",
        selected: false,
    },
    {
        id: 11,
        name: "coffee",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 30000,
        assignedBy: "motitua",
        location: "ocean blark",
        selected: false,
    },
    {
        id: 12,
        name: "crayons for the kids",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 30000,
        assignedBy: "motitua",
        location: "ocean blark",
        selected: false,
    },
    {
        id: 13,
        name: "crease and desist",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
      molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 60000,
        assignedBy: "shoperu",
        location: "crossroad fire",
        selected: false,
    },
    {
        id: 14,
        name: "on the hooks",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 30000,
        assignedBy: "motitua",
        location: "hooked tour",
        selected: false,
    },
    {
        id: 15,
        name: "crossroad",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 60000,
        assignedBy: "shoperu",
        location: "crossroad fire",
        selected: false,
    },
    {
        id: 16,
        name: "a traitor amoung us",
        objective: "Lorem ipsum dolor sit amet consectetur.",
        description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
        molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum.`,
        rewards: 60000,
        assignedBy: "shoperu",
        location: "crossroad fire",
        selected: false,
    },
]

const SKILLS_DATA = [
    {
        id: 1,
        name: "survivor",
        level: 11,
        levelPoints: 21660,
        nextLevelPoints: 65000,
        skillPoints: 0,
        selected: true,
    },
    {
        id: 2,
        name: "agility",
        level: 10,
        levelPoints: 45000,
        nextLevelPoints: 50000,
        skillPoints: 1,
        selected: false,
    },
    {
        id: 3,
        name: "power",
        level: 11,
        levelPoints: 32500,
        nextLevelPoints: 65000,
        skillPoints: 0,
        selected: false,
    },
]

export { QUESTS_DATA, SKILLS_DATA }
